import { render, staticRenderFns } from "./PannelTwo.vue?vue&type=template&id=b820b1ae&scoped=true&"
import script from "./PannelTwo.vue?vue&type=script&lang=js&"
export * from "./PannelTwo.vue?vue&type=script&lang=js&"
import style0 from "./PannelTwo.vue?vue&type=style&index=0&id=b820b1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b820b1ae",
  null
  
)

export default component.exports